import { User } from "./User";
import { PaymentChannel } from "./transaction";

export interface Merchant {
    id: string;
    stage: MerchantStage;
    category: null | string;
    type: MerchantBusinessType;
    name: string;
    tradingName: null | string;
    description: null | string;
    website: string;
    links: Array<MerchantLink>;
    onahID: string;
    email: string;
    phoneNumber: string;
    logo: null | string;
    address: null | string;
    address2: null | string;
    city: null | string;
    state: null | string;
    businessDetails: BusinessDetails;
    registrationNumber: null | string;
    tin: null | string;
    country: null | string;
    registeredYear: null | string;
    ipWhiteList: Array<string>;
    largeShare: boolean;
    kybStatus: KybStatus;
    organizationStructure: null | string;
    paymentChannels: Array<PaymentChannel>
    receiptRecipients: Array<ReceiptRecipient>;
    userId: string;
    accountId: null | string;
    updatedAt: string;
    createdAt: string;
    user: User;
    // team: TeamSettings,
    merchantLink: string;
    apiKey: ApiKey;
    contact: MerchantContact;
}

export interface MerchantContact {
    id: string;
    merchantId: string;
    disputeEmails: Array<string>;
    supportEmails: Array<string>;
    chargebackEmails: Array<string>;
    generalEmail: string;
    createdAt: string;
    updatedAt: string;
}

export enum MerchantBusinessType {
    PRIVATE_CORPORATE = 'PRIVATE_CORPORATE',  
    PUBLIC_CORPORATE = 'PUBLIC_CORPORATE',  
    FREE_ZONE = 'FREE_ZONE',
    INCORPORATED_TRUSTEES = 'INCORPORATED_TRUSTEES',  
    GOVERNMENT_ENTITY = 'GOVERNMENT_ENTITY',
    GOVERNMENT_APPROVED_PRIVATE_ENTITY = 'GOVERNMENT_APPROVED_PRIVATE_ENTITY',  
    COOPERATIVE_SOCIETY = 'COOPERATIVE_SOCIETY'
}

export enum MerchantStage {
    STARTER = 'STARTER',
    REGISTERED = 'REGISTERED'
}


export interface TeamSettings {
    id: string;
    merchantId: string;
    ownerId: string;
    enforce2FA: boolean;
    createdAt: string;
    updatedAt: string;
}
export interface MerchantLink {
    type: string;
    url: string;
}


export interface BusinessDetails {
    address: string;
    address2: string;
    city: string;
    state: string;
    country: string
};


export enum ReceiptRecipient {
    SELF =  'SELF',
    CUSTOMERS = 'CUSTOMERS',
}

export enum KybStatus {
    VERIFIED = 'VERIFIED',
    UNVERIFIED = 'UNVERIFIED',
    REJECTED = 'REJECTED',
    PENDING = 'PENDING',
    STARTED = 'STARTED',
    ABANDONED = 'ABANDONED'
}

export interface ApiKey {
    id: string;
    domain: string;
    publicKey: string;
    key: string;
    createdAt: string;
    updatedAt: string;
    merchantId: string;
}

export interface MerchantBankAccount {
    id: string;
    bankName: string;
    accountNumber: string;
    accountName: string;
    bankCode: string;
    isPrimary: boolean;
    createdAt: string;
    updatedAt: string;
    merchantId: string;
    currency: string;
    country: string;
}